// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-787cf7f9]{font-weight:700;font-size:x-large}", ""]);
// Exports
module.exports = exports;
